import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of } from 'rxjs';
import { Component, OnInit, Input, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { Location } from '@angular/common';
import { ApiService, HttpParamsOptions } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
import { EventEmitter, Output } from '@angular/core';
declare const $: any;
import { debounceTime } from "rxjs/operators";
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl, ValidatorFn, AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { password_validation } from './../../../shared/constants';
import { Config } from 'datatables.net';

class DataTablesResponse {
	data!: any[];
	draw!: number;
	recordsFiltered!: number;
	recordsTotal!: number;
}

@Component({
	selector: 'app-question-list',
	templateUrl: './question-list.component.html',
	styleUrl: './question-list.component.css'
})
export class QuestionListComponent implements OnInit {
	breadcrumbList = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/question-list",
			name: "Question List"
		}
	];
	baseURL = environment.API_URL;
	dtOptions: Config = {};
	@ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
	dataList: any = [];
	deleteLoader: any = null;
	fileUploaderLoader = false;

	constructor(private apiService: ApiService, private router: Router, private activeRoute: ActivatedRoute, private location: Location, private toastr: ToastrService, private http: HttpClient) { }

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.getList();
		});
	}

	getList() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			searching: true,
			language: {
				searchPlaceholder: "Search",
				search: ""
			},
			ajax: (dataTablesParameters: any, callback) => {
				let data: any = {
					"search": dataTablesParameters.search.value,
					"draw": dataTablesParameters.draw,
					"start": dataTablesParameters.start,
					"length": dataTablesParameters.length
				};
				const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
				const options = { params: new HttpParams(httpParams) };
				this.http.get<DataTablesResponse>(this.baseURL + "listquestion", options).subscribe({
					next: (resp) => {
						this.dataList = resp.data;
						callback({
							recordsTotal: resp.recordsTotal,
							recordsFiltered: resp.recordsFiltered,
							res: []
						});
					}, error: (error) => {
						this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
					}
				});
			}
		};
	}

	deleteModal(apptId: any) {
		Swal.fire({
			title: 'Warning !!!',
			text: 'Are you sure you want to delete record?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#f23022'
		}).then((result) => {
			if (result.value) {
				this.deleteLoader = apptId;
				this.apiService.deleteQuestion(apptId).subscribe({
					next: (data: any) => {
						this.deleteLoader = null;
						Swal.fire('Success', 'Record Deleted Successfully.', 'success');
						this.refreshTable();
					}, error: (error: any) => {
						this.deleteLoader = null;
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			}
		})
	}

	refreshTable() {
		this.datatableElement.dtInstance.then((dtInstance) => {
			dtInstance.draw();
		});
	}

	refreshPage() {
		this.router.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
			this.router.navigate(['/app/question-list']);
		});
	}
}
